module.exports = {
  path: ':reference/overstay',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MyOnDemandAccessOverstay'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_on_demand_access/routes/overstay/index.js